interface ShouldRedirectToSharedListingOptions {
  isLoggedIn: boolean;
  isSmallUI: boolean;
  isStarting: boolean;
  isWeb?: boolean;
}

export function shouldRedirectToSharedListing({
  isLoggedIn,
  isSmallUI,
  isStarting,
  isWeb = false,
}: ShouldRedirectToSharedListingOptions) {
  return !isWeb && !isStarting && !isLoggedIn && !isSmallUI;
}
